import { Link } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Badge } from "@odingard/design-system";
import { EmptyState, ErrorState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";
import { useAsync } from "../../lib/useAsync";
import { proposalApi } from "../../lib/api";
import { DemoModeBanner, LiveModeBadge } from "../../components/ProposalGrounded";

export function PaiWorkspace() {
  const { activeOrg } = useAuth();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(async () => proposalApi.workspaces(orgId), [orgId]);
  const workspaces = state.data?.data.workspaces ?? [];

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Proposal Workspaces</h1>
          <p>Author sections with grounded AI drafting and immutable versioning.</p>
        </div>
        <LiveModeBadge demoMode={state.data?.demoMode ?? false} />
      </div>

      <DemoModeBanner show={state.data?.demoMode ?? false} />
      {state.loading && <LoadingState label="Loading workspaces…" />}
      {state.error && <ErrorState description={state.error.message} onRetry={state.reload} />}
      {!state.loading && workspaces.length === 0 && (
        <EmptyState
          title="No workspaces yet"
          description="Open an opportunity and create a workspace to begin authoring."
        />
      )}
      {workspaces.length > 0 && (
        <div className="ods-stack">
          {workspaces.map((w) => (
            <Card key={w.id}>
              <CardHeader
                title={w.title}
                action={
                  <Link to={`/studio/proposal-ai/workspace/${w.id}`}>
                    <Button size="sm">Open</Button>
                  </Link>
                }
              />
              <CardBody>
                <div className="ods-row" style={{ justifyContent: "space-between" }}>
                  <Badge tone="info">{w.status}</Badge>
                  <Link
                    to={`/studio/proposal-ai/opportunities/${w.opportunityId}`}
                    style={{ color: "var(--ods-color-muted)", fontSize: "var(--ods-text-sm)" }}
                  >
                    View opportunity
                  </Link>
                </div>
              </CardBody>
            </Card>
          ))}
        </div>
      )}
    </>
  );
}
